import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import { useAnchoredPopover } from './useAnchoredPopover';
export default function Popover({ isOpen, onClose, renderTrigger, children, matchTriggerWidth = false, expand, defaultMaxHeight, viewportPadding, gap, zIndex = 'z-above-dropdown', className, testId, }) {
    const { triggerRef, popoverRef, position } = useAnchoredPopover({
        isOpen,
        onClose,
        expand,
        defaultMaxHeight,
        viewportPadding,
        gap,
    });
    const widthStyle = matchTriggerWidth ? { width: position?.width } : { minWidth: position?.width };
    return (_jsxs(_Fragment, { children: [renderTrigger(triggerRef), isOpen &&
                position &&
                createPortal(_jsx("div", { ref: popoverRef, className: classNames('bg-primary border-stroke-base-medium fixed overflow-hidden rounded-xl border shadow-lg', zIndex, className), style: {
                        top: position.top,
                        left: position.left,
                        maxHeight: position.maxHeight,
                        ...widthStyle,
                    }, "data-testid": testId, children: children }), document.body)] }));
}
